import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  IconButton,
  Grid,
  Box,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { DescriptionInputComponent } from "../../../../common/components";
interface MarkAsClosedPopupProps {
  open: boolean;
  onCancel: () => void;
  onOkay: (value: string) => void;
  title: string;
  description?: string;
}
const MarkAsClosedPopup: React.FC<MarkAsClosedPopupProps> = ({
  open,
  onCancel,
  title,
  onOkay,
}) => {
  const [notes, setNotes] = useState("");
  const [notesError, setNotesError] = useState("");

  useEffect(() => {
    if (open) {
      setNotes("");
      setNotesError("");
    }
  }, [open]);
  return (
    <>
      <Dialog
        open={open}
        fullWidth
        maxWidth="sm"
        slotProps={{
          paper: {
            sx: {
              minWidth: "650px",
              // minHeight: "108px",
              position: "absolute",
              top: 0,
              margin: 0,
            },
          },
        }}
      >
        <DialogTitle
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: 1,
            paddingLeft: 3,
            borderBottom: "1px solid #E1E1E1",
          }}
        >
          <Typography
            variant="h6"
            sx={{ fontWeight: "bold !important" }} // You can also use 700 or 'bold'
          >
            {title}
          </Typography>
          <IconButton onClick={onCancel}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent sx={{ paddingTop: "20px !important" }}>
          {/* Notes */}
          <Grid item xs={12}>
            <Box
              display="flex"
              alignItems="center"
              gap={6}
              className="mark-as-closed-notes-box"
            >
              <Typography width={200}>Notes</Typography>
              <Box flex={1}>
                <DescriptionInputComponent
                  fieldName="notes"
                  label="Notes"
                  placeholder="Add Notes"
                  value={notes}
                  rows={4}
                  onChange={(e: any) => {
                    setNotes(e?.target?.value);
                    if (e?.target?.value) setNotesError("");
                    else setNotesError("Notes is required");
                  }}
                  renderErrorMessage={false}
                />
              </Box>
            </Box>
            {notesError && <div className="error-message">{notesError}</div>}
          </Grid>
        </DialogContent>
        <DialogActions sx={{ margin: "12px" }}>
          <button type="button" onClick={onCancel} className="mark-as-closed-cancel-btn">
            Cancel
          </button>
          <button
            type="button"
            className="mark-as-closed-save-btn"
            onClick={() => {
              if (!notes) {
                setNotesError("Notes is required");
                return;
              }
              onOkay(notes);
            }}
          >
            Mark As Closed
          </button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default MarkAsClosedPopup;
